import { InvoicePaymentRequestStatus } from "shared/enums/InvoicePaymentRequestStatus";
import TicketStatus from "../../../../shared/enums/TicketStatus";

export function isPaymentPending(ticketStatus: TicketStatus) {
  return [TicketStatus.PAYMENT_FLOW_PAYMENT_PENDING, TicketStatus.APPLICATION_FLOW_PAYMENT_PENDING].includes(
    ticketStatus
  );
}

export function isPaymentReceiptPending(ticketStatus: TicketStatus) {
  return TicketStatus.PAYMENT_RECEIPT_PENDING === ticketStatus;
}

export function isApprovalPending(ticketStatus: TicketStatus) {
  return (
    [TicketStatus.PAYMENT_FLOW_APPROVAL_PENDING, TicketStatus.APPLICATION_FLOW_APPROVAL_PENDING].includes(
      ticketStatus
    ) || isPaymentReceiptPending(ticketStatus)
  );
}

export function isInvoicePaymentPending(invoicePaymentRequestStatus?: InvoicePaymentRequestStatus) {
  return invoicePaymentRequestStatus === InvoicePaymentRequestStatus.PENDING;
}

export enum PurchaseTicketStep {
  SHOW_COUPON_CODE_FORM = 0,
  SHOW_REG_FORM = 1,
  SHOW_PAYMENT_FORM = 2,
  SHOW_CONFIRMATION_VIEW = 3,
  SHOW_INVOICE_PAYMENT_VIEW = 4
}
